import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { CaptchaHostStore } from './captchaHostStore';

/** @knip-ignore */
export const {
	Context: CaptchaHostStoreContext,
	Provider: CaptchaHostStoreProvider,
	useContext: useCaptchaHostStoreContext,
} = createMandatoryContext<CaptchaHostStore>(undefined, {
	name: 'CaptchaHostStoreContext',
});
